import { connect } from 'react-redux';

import FiltersRow from '@/components/FiltersRow';
import {
  removeFilters,
  updateFilters,
} from '@/features/campaignsStatisticsDetailsPage/actions';
import {
  getFilters,
  getFiltersTypes,
} from '@/features/campaignsStatisticsDetailsPage/selectors';

const mapStateToProps = state => ({
  filters: getFilters(state),
  filterTypes: getFiltersTypes(state),
});

const mapDispatchToProps = { removeFilters, updateFilters };

export default connect(mapStateToProps, mapDispatchToProps)(FiltersRow);
